import { ICompany } from "data/company";
import { TExtraData } from "pages/EtcInsertEntryInfoPage/EtcInsertEntryInfoPage";
import { fetcher } from "utils/ApiUtil";

export type ICategoryType = string;

export interface ICompanyCategory {
  no?: number;
  category?: ICategoryType;
  ordering?: number;
  home_yn?: "Y" | "N";
  del_yn?: "Y" | "N";
}

export async function getCompanyCategoryList() {
  return await fetcher<{ result: ICompanyCategory[] }>(
    "/api/contructor/categoryList"
  );
}

export async function contructorReserveClick({
  contructor_no,
  contructor_spot_no,
}: {
  contructor_no: number;
  contructor_spot_no?: number;
}) {
  return await fetcher<{ result: ICompanyCategory[] }>(
    "/api/contructor/reserveClick",
    { contructor_no, contructor_spot_no }
  );
}

export async function getCompanyDetail(contructor_no: string) {
  return await fetcher<{
    result: ICompany;
  }>("/api/contructor/contructordetail", {
    contructor_no,
  });
}

export async function addCart({
  contructor_no,
  contructor_spot_no,
}: {
  contructor_no: number; // 업체 번호
  contructor_spot_no?: number | undefined;
}) {
  return await fetcher("/api/user/addCart", {
    contructor_no,
    contructor_spot_no: contructor_spot_no || null,
  });
}

export async function checkInquiry({
  contructor_no,
  contructor_spot_no,
  extra_data_title,
}: {
  contructor_no: number;
  contructor_spot_no?: number;
  extra_data_title?: string;
}) {
  return await fetcher("/api/user/checkInquiry", {
    contructor_no,
    contructor_spot_no: contructor_spot_no || null,
    extra_data_title,
  });
}
export async function addDirectInquiry({
  contructor_no,
  contructor_spot_no,
  title,
  bride_name,
  bride_phone,
  groom_name,
  groom_phone,
  wedding_day,
  filming_day,
  extra_data,
  cart_check,
  select_item_list,
}: {
  contructor_no: number;
  contructor_spot_no?: number | null;
  title: string;
  bride_name: string;
  bride_phone: string;
  groom_name: string;
  groom_phone: string;
  wedding_day?: string;
  filming_day?: string;
  extra_data?: TExtraData[] | [];
  cart_check?: "Y" | "N";
  select_item_list?: { product_no: number }[] | [];
}) {
  return await fetcher("/api/user/addDirectInquiry", {
    contructor_no,
    contructor_spot_no: contructor_spot_no,
    title,
    bride_name,
    bride_phone,
    groom_name,
    groom_phone,
    wedding_day,
    filming_day,
    extra_data,
    cart_check,
    select_item_list,
  });
}
